import { IAccountDetails } from "../interface/IOffer";

export interface IAccountListResponse {
    content: IAccountResponse[];
}

export interface IAccountResponse {
    id: string;
}

export const getResponseToState = (response: IAccountListResponse): IAccountDetails => ({
    id: response.content[0].id,
});
